import { FC, useState } from 'react';
import ImagePreviewDialog from '../molecules/image-preview-dialog';
import { ImageFallbackContainerStyled, ToolCategoryIcon } from './styled';

export const ImageFallback: FC<any> = ({ src, fallbackComponent: FallbackComponent, fallbackName, alt, ...rest }) => {
  const [error, setError] = useState<boolean>(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const handleImageError = () => {
    setError(true);
  };

  const getImage = () => {
    if ((error || !src) && fallbackName) {
      return (
        <ToolCategoryIcon className={`icon-tools-consumables icon-${fallbackName.toLowerCase()}`}></ToolCategoryIcon>
      );
    } else if ((error || !src) && FallbackComponent) {
      return <FallbackComponent />;
    } else return <img src={src} alt={alt} onError={handleImageError} height="30" width="30" {...rest} />;
  };

  const handleImageClick = () => {
    if (!error && src) {
      setShowPreviewModal(true);
    }
  };

  return (
    <>
      <ImageFallbackContainerStyled
        justifyContent={{ sm: 'center' }}
        alignItems={{ sm: 'center' }}
        onClick={handleImageClick}
        css={{ cursor: !error && src ? 'pointer' : 'default' }}
      >
        {getImage()}
      </ImageFallbackContainerStyled>
      {showPreviewModal && <ImagePreviewDialog src={src} alt={alt} onClose={() => setShowPreviewModal(false)} />}
    </>
  );
};
